import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import StartPage from './pages/StartPage';
import ResultsPage from './pages/ResultsPage';
import ContactPage from './pages/ContactPage';
import ThanksPage from './pages/ThanksPage';
import NotFoundPage from './pages/NotFoundPage';
import { ErrorProvider } from './components/common/ErrorHandling';

const App: React.FC = () => {
  return (
    <ErrorProvider>
      <Router>
        <Routes>
          <Route path="/" element={<StartPage />} />
          <Route path="/survey" element={<HomePage />} />
          <Route path="/results" element={<ResultsPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/thanks" element={<ThanksPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Router>
    </ErrorProvider>
  );
};

export default App;
